import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import NewMain from '../headerone/newMain'
function RegistersMessage() { 
  return (
    <>
      <NewMain />
      <Bredcom title="Home" subtitle="Registrar’s Message" />
      <section className="about-area about-p pt-60 pb-60 p-relative fix">
        <div className="animations-02">
          <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
        </div>
        <div className="container">
          <div className="row justify-content-center ">
            <div className="col-lg-4 col-md-12 col-sm-12">
              <div className="wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s" > 
                <img src={`${process.env.PUBLIC_URL}/assets/img/new_images/yogender_singh01.jpg`}  alt="img" className="vc-img" />
                <div className="vc-about"> 
                  <p><strong>Prof. (Dr.) Yogendra Singh </strong> <br/> (Registrar)  </p> 
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                <div className="about-title second-title pb-25">
                  {/* <h5>
                    <i className="fal fa-graduation-cap" /> Chancellor’s Message
                  </h5> */}
                  <h2>Registrar’s Message</h2>
                </div>
                <p >
                Welcome to MVN University! <br/> <br/>
 
 The future belongs to those who believe in igniting their minds. At MVN University, our motto “Igniting Minds” translates into nurturing talent, fostering innovation, and equipping students with the skills needed to thrive in their careers.
 Driven by a strong sense of purpose and a mission to inspire young minds to excel in their chosen academic paths, MVN University has earned a distinguished reputation in the global academic community. The University’s unwavering dedication is reflected in its dynamic leadership, modern infrastructure, cutting-edge laboratories, and a team of highly skilled and experienced faculty. Its commitment to excellence in teaching and learning has established it as a premier destination for higher education. <br/> <br/>
 To align with global academic echelons, MVN University has adopted the Outcome-Based Education (OBE) model, integrating project-based learning into its curriculum. Combined with a Choice-Based Credit System (CBCS) and continuous evaluation through grade point averages, this approach ensures a well-rounded and internationally competitive educational experience. With a diverse range of academic programs, experienced faculty, and modern facilities, MVN University provides a dynamic and supportive learning environment. <br/> <br/>
 Welcoming students from around the world, the University offers a supportive and inclusive residential environment. Separate hostels for male and female students provide a safe and comfortable ‘home away from home.’ Thoughtful planning and attention to detail ensure hygienic food and quality on-campus services for all residents. <br/> <br/>
 Believing strongly in holistic education, we encourage students to maximize their university experience by actively participating in learning and research with a greater involvement in diverse areas such as sports, theatre, cultural activities, and more. MVN University provides numerous platforms for students to develop their talents beyond the classroom. We also invite parents and the community to join us in shaping our students' futures. Your support is invaluable in our mission to provide quality education and make a meaningful impact on society. We solicit your participation in the MVN University community, experience our world-class facilities, and help shape a brighter future for the next generation.
 <br/>
 I look forward to welcoming you to MVN University and supporting your academic journey.<br/><br/>
 
 Prof. (Dr.) Yogendra Singh<br/>
 (Registrar)
 
                
                </p>
                                
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default RegistersMessage